(function(window, angular) {'use strict';

  var service = angular.module('service', []);

  /**
   * datepicker
   */
  service.directive('datepicker', function(){
    return {
      require: 'ngModel',

      scope: {
        ngModel: '=',  // Bind the ngModel to the object given
      },

      template:
      '<div class="input-group datepicker">' +
        '<span class="input-group-addon" ng-transclude></span>' +
        '<input type="text" ng-model="myModel" class="form-control inpTime" ng-click="clear()">' +
        '<span class="input-group-btn">' +
          '<button class="btn btn-default" type="button"><i class="fa fa-calendar"></i></button>' +
        '</span>' +
      '</div>',

      restrict: 'E',
      transclude: true,

      controller: ['$scope', function($scope) {
        $scope.clear = function() {
          $scope.ngModel = null;
        }
      }],

      link: function(scope, elem, attr) {
        var input = $(elem).find('.inpTime')[0];
        var btn = $(elem).find('.btn')[0];
        var addon = $(elem).find('.input-group-addon')[0];

        var datepicker = $(input).datepicker({
          //showOn: "button",
          buttonText: '',
          changeMonth: true,
          changeYear: true,
          showOtherMonths: true,
          selectOtherMonths: true,
          onSelect: function(date, inst) {
            scope.ngModel = datepicker.datepicker('getDate');
            scope.$apply();
          }
        });

        $(btn).on('click', function() {
          datepicker.datepicker('show');
        });

        if( !$(addon).html() ) {
          $(addon).remove();
        }

        var unregisterNgModel = scope.$watch('ngModel', function(newVal, oldVal) {
          if( newVal != null ) {
            datepicker.datepicker('setDate', newVal);
          }
        });

        var unregisterMyModel = scope.$watch('myModel', function(newVal, oldVal) {
          if( newVal != oldVal ) {
            scope.ngModel = datepicker.datepicker('getDate');
          }
        });

        $('#ui-datepicker-div').hide();
        //datepicker.hide()
        //datepicker.mask("99/99/9999");
        //
        scope.$on('$destroy', function() {
          unregisterNgModel();
          unregisterMyModel();
        });
      }
    };
  });

  /**
   * open-dialog
   */
  service.directive('openDialog', function(){
    return {
      require: 'ngModel',
      scope: {
        ngModel: '=',  // Bind the ngModel to the object given
        onConfirm: '&',
      },
      restrict: 'A',
      link: function(scope, elem, attr, ctrl) {
        elem.bind('click', function(e) {
          var dialogId = '#' + attr.openDialog;
          $(dialogId).dialog({
            autoOpen: true,
            title: attr.title || "Suppression",
            modal: true,
            width: 400,
            closeOnEscape: true,
            dialogClass: attr.dialogClass || "supprDialog",
            buttons: {
              "Annuler": {
                click: function() { $( this ).dialog( "close" ); },
                text:"Annuler",
                class:"btn-default"
              },
              "Confirmer": {
                click: function() {
                  scope.onConfirm();
                  $( this ).dialog( "close" );
                },
                text:"Confirmer",
                class:"btn-default btn-valid"
              }
            },
            open : function(event, ui){ $(".ui-widget-overlay").css({ background:"#000" }); },
            beforeClose: function(event, ui) {  }
          });
          //$(dialogId).dialog('open');
        });
      }
    };
  });

  service.directive('autoscroll', ['$timeout', function($timeout) {
    return {
    restrict: 'A',
    link: function(scope, element, attr) {
      scope.$watchCollection(attr.autoscroll, function(newVal) {
        $timeout(function() {
          element[0].scrollTop = element[0].scrollHeight;
        });
      });
    }
    }
  }]);

  service.directive('onKeyEnterDown', function () {
    return function (scope, element, attrs) {
      element.bind("keydown keypress", function (event) {
        if(event.which === 13) {
          scope.$apply(function (){
            scope.$eval(attrs.onKeyEnterDown);
          });

          event.preventDefault();
        }
      });
    };
  });

  /*
   Isolate a nested form from its parent for the validation process
   */
  service.directive('isolateForm', [function () {
    return {
      restrict: 'A',
      require: '?form',
      link: function (scope, elm, attrs, ctrl) {
        if (!ctrl) {
          return;
        }

        // Do a copy of the controller
        var ctrlCopy = {};
        angular.copy(ctrl, ctrlCopy);

        // Get the parent of the form
        var parent = elm.parent().controller('form');
        // Remove parent link to the controller
        parent.$removeControl(ctrl);

        // Replace form controller with a "isolated form"
        var isolatedFormCtrl = {
          $setValidity: function (validationToken, isValid, control) {
            ctrlCopy.$setValidity(validationToken, isValid, control);
            parent.$setValidity(validationToken, true, ctrl);
          },
          $setDirty: function () {
            elm.removeClass('ng-pristine').addClass('ng-dirty');
            ctrl.$dirty = true;
            ctrl.$pristine = false;
          },
        };
        angular.extend(ctrl, isolatedFormCtrl);
      }
    };
  }]);


  service.filter('cutStringAt', function() {
    return function(input, maxLength) {
      var str = '';
      if( input && input.length ) {
        str = input;
        if( input.length >= maxLength ) {
          var idx = Math.min(input.length, maxLength-3);
          str = input.substr(0, idx) + '...';
        }
      }
      return str;
    };
  });

  service.filter('transList', ['configService', function(configService) {
    return function(input, key) {
      if( configService.locale[key] && configService.locale[key][input] ) {
        return configService.locale[key][input];
      }
      return input;
    };
  }]);

  service.filter('trans', ['configService', function(configService) {
    return function(input, key, token) {
      if( configService.locale[key] ) {
        if( token ) {
          return configService.locale[key].replace(':' + token, input);
        }
        return configService.locale[key];
      }
      return input;
    }
  }]);

  service.filter('transChoice', ['configService', function(configService) {
    return function(input, key, token) {
      var translation = configService.locale[key] ? configService.locale[key] : null;

      if( !translation ) {
        // no trans key
        return input;
      }

      var chunks = translation.split('|');
      if( chunks.length == 1 ) {
        // no choice => classic trans
        return translation.replace(':' + token, input);
      }

      input = Math.ceil(input);

      for( var i=0; i<chunks.length; i++ ) {
        var str = chunks[i];
        var pos = str.indexOf(' ');
        var interval = str.substr(0, pos);
        var text = str.substr(pos);

        // check for a value
        var pattern = /\{(\d*)\}/;
        var match = pattern.exec(interval);
        if( match && match.length>1 ) {
          if( match[1] == input ) {
            return text.replace(':' + token, input);
          }
        }

        // check for an interval
        pattern = /\[(\d*),(\w*|\d*)\]/;
        match = pattern.exec(interval);

        if( match && match.length>2 ) {
          var end = parseInt(match[2]);
          if( isNaN(end) ) {
            end = input;
          }

          if( match[1] <= input && input <= end ) {
            return text.replace(':' + token, input);
          }
        }
      }
    }
  }])

  /**
   * directive to help converting select with integer options.value !
   * http://stackoverflow.com/questions/30582906/angularjs-1-4-select-list-value-not-initializing-correctly-when-list-is-inserted
   */
  service.directive('convertToNumber', function() {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel) {
        ngModel.$parsers.push(function(val) {
          return parseInt(val, 10);
        });
        ngModel.$formatters.push(function(val) {
          return parseInt(val);
        });
      }
    };
  });

  service.directive('convertToString', function() {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel) {
        /*ngModel.$parsers.push(function(val) {
          return parseInt(val, 10);
        });*/
        ngModel.$formatters.push(function(val) {
          return '' + (val);
        });
      }
    };
  });


  /**
   * ng-from-now watch a locale date to make it alive !
   */
  service.directive('ngFromNow', ['$interval', '$filter', function($interval, $filter) {
    return {
      require: 'ngModel',

      scope: {
        ngModel: '=',  // Bind the ngModel to the object given
      },

      controller: ['$scope', '$interval', '$filter',
           function($scope,   $interval,   $filter ) {
        var promise = null;

        $scope.start = function() {
          var now  = new Date().getTime();
          var date = new Date($scope.ngModel).getTime();

          if( now - date > (3600*1000*10) ) {
            // display date if > 10 hours
            $scope.fromNow = $filter('localeDatetime')($scope.ngModel);
          }
          else {
            $scope.run(); // run it right now
            $scope.promise = $interval($scope.run, 60*1000);
          }
        };

        $scope.run = function() {
          $scope.fromNow = $filter('dateFromNow')($scope.ngModel);
        }

        $scope.stop = function() {
          if( $scope.promise  ) {
            $interval.cancel($scope.promise);
            $scope.promise = null;
          }
        }
      }],

      template: "{{ fromNow }}",

      link: function(scope, iElement, iAttrs) {
        scope.start();

        var unregister = scope.$watch('ngModel', function(newVal, oldVal) {
          if( newVal && newVal != oldVal ) {
            scope.stop();
            scope.start();
          }
        });

        scope.$on('$destroy', function() {
          unregister();
          scope.stop();
        });


      }
    }
  }]);


  /**
   * ng-from-now watch a locale date to make it alive !
   */
  service.directive('ngPager', ['$filter', '$timeout', function( $filter, $timeout ) {
    return {
      require: 'ngModel',
      transclude: true,

      scope: {
        ngModel: '=',  // Bind the ngModel to the current page
        totalPages: '=',
        ngChange: '&',
      },

      controller: ['$scope', '$filter', '$timeout',
         function($scope,   $filter,   $timeout ) {
        $scope.pages = [];
        $scope.maxPages = 10;

        $scope.goToPage = function(page) {
          if( page != $scope.ngModel ) {
            $scope.ngModel = page;
            $timeout($scope.ngChange, 0); // It automatically launches a $digest cycle just after the callback is executed
          }
        }

        $scope.goToPrevious = function() {
          $scope.goToPage($scope.ngModel-1);
        }
        $scope.goToNext = function() {
          $scope.goToPage($scope.ngModel+1);
        }

        $scope.update = function() {
          $scope.pages = [];
          var totalPages = $scope.totalPages || 0;
          var start = $scope.ngModel || 1;
          var end = start + $scope.maxPages;

          if( end > totalPages ) {
            end = totalPages;

            start = end - $scope.maxPages;

            if( start < 1 ) {
              start = 1;
            }
          }

          for( var i=start; i<=end; i++ ) {
            $scope.pages.push(i);
          }
        }
      }],

      template: '<div class="npage" ng-show="totalPages>1">' +
                '<a class="pgnav" ng-show="ngModel>1" href ng-click="goToPage(1)">&lt;&lt;</a>' +
                '<a class="pgnav" ng-show="ngModel>1" href ng-click="goToPrevious()">&lt;</a>' +
                '<a ng-repeat="page in pages" href ng-click="goToPage(page);" ng-class="page == ngModel ? \'pgnavon\' : \'pgnav\'">{{ page }}</a>' +
                '<a class="pgnav" ng-show="ngModel<totalPages" href ng-click="goToNext()">&gt;</a>' +
                '<a class="pgnav" ng-show="ngModel<totalPages" href ng-click="goToPage(totalPages)">&gt;&gt;</a>' +
                '</div>',

      link: function(scope, iElement, iAttrs) {
        scope.$watch('ngModel', function(newVal) {
          scope.update();
        });
        scope.$watch('totalPages', function(newVal) {
          scope.update();
        });
      }
    }
  }]);

  /**
   * orderBy directive for table th columns
   * Used in index.js controllers
   */
  service.directive('ngOrderBy', ['$scope', function($scope) {
    return {
      require: 'ngModel',
      transclude: true,
      scope: {
        ngModel: '=',  // Bind the ngModel to the object given
        ngChange: '&', // reference of the method to reload data
        orderByName: '=', // Store the string associated by orderByName
        orderByAsc: '=' // Bind the variable
      },
      controller: ['$scope', function($scope) {
        $scope.myclass = '';
      }],
      template: '<ng-transclude></ng-transclude>' +
                '<i class="order-by-icon fa {{ myclass }}">&nbsp;</i>',
      link: function(scope, iElement, iAttrs) {
        iElement.addClass('order-by-column');

        scope.$watch('orderByName', function(newVal, oldVal) {
          if( newVal == scope.ngModel ) {
            scope.myclass = scope.orderByAsc ? "lnr-sort-amount-asc" : "lnr-sort-amount-desc";
          }
          else {
            scope.myclass = "fa-invisible";
          }
        });

        scope.$watch('ngModel', function(newVal) {
          if( newVal != scope.orderByName ) {
            scope.myclass = "fa-invisible";
          }
          else {
            scope.myclass = scope.orderByAsc ? "lnr-sort-amount-asc" : "lnr-sort-amount-desc";
          }
        });

        scope.$watch('orderByAsc', function(newVal) {
          if( scope.ngModel == scope.orderByName ) {
            scope.myclass = scope.orderByAsc ? "lnr-sort-amount-asc" : "lnr-sort-amount-desc";
          }
        });

        iElement.bind('click', function(e) {
          if( scope.ngModel == scope.orderByName ) {
            scope.orderByAsc = !scope.orderByAsc;
          }
          else {
            scope.ngModel = scope.orderByName;
            scope.orderByAsc = false;
          }

          scope.$apply(); // update bindings before
          scope.ngChange();
        });
      }
    }
  }]);

  /**
   * dateColorAlert
   * Change color of the date depending on its age
   */
  service.directive('dateColorAlert', function() {
    return {
      //require: 'ngModel',
      scope: {
        ngModel: '=',  // Bind the ngModel to the object given
        dateValue: '@',
      },
      link: function(scope, iElement, iAttrs) {
        var updateCSS = function(newVal) {
          if( !newVal ) {
            return;
          }

          var date = new Date(newVal);
          var now  = new Date();
          var diff = Math.ceil( (date.getTime() - now.getTime()) / (1000 * 3600 * 24) ); // days
          var normalClass  = iAttrs.normalClass  || 'normal';
          var warningClass = iAttrs.warningClass || 'warning';
          var dangerClass  = iAttrs.dangerClass  || 'danger';

          $(iElement).removeClass(normalClass + ' ' + warningClass + ' ' + dangerClass);
          if( diff >= 4 ) {
            $(iElement).addClass(normalClass);
          }
          else if( diff >= 2 ) {
            $(iElement).addClass(warningClass);
          }
          else {
            $(iElement).addClass(dangerClass);
          }
        };

        if( scope.ngModel ) {
          updateCSS(scope.ngModel);

          if( !(iAttrs.dateWatch && iAttrs.dateWatch === false) ) {
            // default behavior => Watch for updates
            var unregister = scope.$watch('ngModel', function(newVal, oldVal) {
              if( newVal ) {
                updateCSS(newVal);
              }
            });

            scope.$on('$destroy', function() {
              unregister();
            });
          }
        }
        else if( scope.dateValue ) {
          updateCSS(scope.dateValue);
        }
      }
    }
  });

  /**
   * orderBy directive for table th columns
   * Used in index.js controllers
   */
  service.directive('ngTrend', function() {
    return {
      require: 'ngModel',
      transclude: true,
      scope: {
        ngModel: '=',  // Bind the ngModel to the object given
        ngChange: '&', // reference of the method to reload data
        invertColors: '@', // copy
        hideIcon: '@', // copy
      },
      controller: function($scope) {
        $scope.rotateIcon = '';
        $scope.value = 0;
        $scope.class = '';
        $scope.invertColors = false;
        $scope.hideIcon = false;
      },
      template: '<ng-transclude></ng-transclude>' +
                '<span ng-hide="value==0" ng-class="[\'trend\', \'label\', class]">' +
                '<i class="icon lnr {{ rotateIcon }}"></i>' +
                '<span class="value">{{ value }}%</span>' +
                '</span>',
      link: function(scope, iElement, iAttrs) {
        scope.$watch('ngModel', function(newVal) {
          if( isNaN(newVal) || Math.abs(newVal) < 1 ) {
            scope.value = 0;
            return;
          }

          scope.value = Math.round(newVal, 0);
          var success = false;
          if( newVal < 0 ) {
            success = false;
            scope.rotateIcon = "lnr-arrow-down";
          }
          else {
            success = true;
            scope.rotateIcon = 'lnr-arrow-up';
          }

          if( scope.hideIcon ) {
            scope.rotateIcon = 'hidden';
          }

          scope.class = (success && !scope.invertColors) || (!success && scope.invertColors) ? "label-success" : "label-danger";
        });
      }
    }
  });

  /**
   * date localization depending on Laravel locale.php file
   */
  service.filter('localeDate', ['$filter', 'configService', function($filter, configService){
    var standardDateFilterFn = $filter('date');
    return function(dateToFormat){
     return standardDateFilterFn(dateToFormat, configService.locale.date);
    }
  }]);

  service.filter('dateFromNow', ['$filter', 'configService', function($filter, configService){
    var transChoice = $filter('transChoice');
    return function(input) {

      var now  = new Date();
      var date = new Date(input);
      var diff = (now.getTime() - date.getTime()) / (1000 *60); // minutes

      if( diff<60 ) {
        return transChoice(diff, 'x minute(s) ago', 'minutes');
      }
      else if( diff<1440 ) {
        // 24h * 60min
        return transChoice(diff/60, 'x hour(s) ago', 'hours');
      }
      else {
        return transChoice(diff/1440, 'x day(s) ago', 'days');
      }
    }
  }]);

  /**
   * datetime localization depending on Laravel locale.php file
   */
  service.filter('localeDatetime', ['$filter', 'configService', function($filter, configService){
    var standardDateFilterFn = $filter('date');
    return function(dateToFormat){
     return standardDateFilterFn(dateToFormat, configService.locale.datetime);
    }
  }]);

  /**
   * Convert mysql date YYYY-MM-DD hh:mm:ss to locale formatted string
   * @param  [string] format of the wanted date laravel locale.date or locale.datetime
   * @return [string] formatted date
   */
  service.filter('transdate', function() {
    return function(input, format) {
      var result = input;
      //                                                      year(1)-month(2)-day(3) hour(5)-minute(6)-second(7)
      var parsed = input.match(/(\d{2,4})-(\d{2})-(\d{2}) ((\d{2}):(\d{2}):(\d{2}))?/);
      if( parsed && parsed.length>3 ) {
        result = format;
        result = result.replace(/yyyy/g, parsed[1].substr(0, 4));
        result = result.replace(/yy/g, parsed[1].substr(2, 2));
        result = result.replace(/MM/g, parsed[2]);
        result = result.replace(/dd/g, parsed[3]);

        if( /hh/.test(format) && parsed.length>4 ) {
          result = result.replace(/hh/g, parsed[5]);
          result = result.replace(/mm/g, parsed[6]);
          result = result.replace(/ss/g, parsed[7]);
        }
      }

      return result;
    };
  });

  service.filter('localeCurrency', ['$locale', '$filter', function($locale, $filter) {
    var formats = $locale.NUMBER_FORMATS;
    return function(amount, currencySymbol, fractionSize) {
    if( typeof currencySymbol === 'undefined' ) {
      currencySymbol = formats.CURRENCY_SYM;
    }

    if( typeof fractionSize === 'undefined' ) {
      fractionSize = 0;
    }

    if( !amount ) {
      amount = 0;
    }

    var unit = null;
    if( amount > 1000000 ) {
      unit = 'M';
      amount /= 1000000;
    }
    if( amount >= 1000 ) {
      unit = 'k';
      amount /= 1000;
    }

    var formatted = $filter('currency')(amount, currencySymbol, fractionSize);
    if( unit ) {
      var regexp = new RegExp(currencySymbol, "g");
      formatted = formatted.replace(regexp, unit+currencySymbol);
    }

    return formatted;
  };
  }]);
})(window, window.angular);
